import React, { useEffect, useState } from "react";
import _ from "lodash";
import Form from "forms/Form";
import { QUIZ_QUESTIONS, QUIZ_QUESTION_OPTIONS } from "api/config/endpoints";
import formWrapper from "hoc/formWrapper";
import useMultilangForm from "hooks/useMultilangForm";
// import { getQuizCategory } from "api/functions/functions";
import { Loading } from "carbon-components-react";

const QuizQuestionOptionForm = ({ questionId, ...props }) => {

    const [loaded, setLoaded] = useState(true);
    const [itemId, setItemId] = useState();
    const [saving, setSaving] = useState(false);
    const [defaultValues, setDefaultValues] = useState({});

    const {
        _selectedLangCode,
        _defaultParams,
        _languageSelect
    } = useMultilangForm({
        label: "Select language",
        modal: true
    })

    useEffect(() => {
        if (!props.itemId) {
            setDefaultValues({})
            return
        }
        // loadData(props.itemId)
    }, [props.itemId])

    useEffect(() => {
        setDefaultValues(props.defaultValues)
    }, [props.defaultValues])

    useEffect(() => {
        setItemId(defaultValues?.id)
    }, [defaultValues])


    // const loadData = async (itemId) => {
    //     setLoaded(false)
    //     const res = await getQuizCategory(itemId);
    //     try {
    //         if (res) {
    //             setDefaultValues(res);
    //             setItemId(res.id)
    //         }
    //     }
    //     catch (e) {
    //     }
    //     finally {
    //         setLoaded(true)
    //     }
    // }

    const getValue = (name, type) => {
        let value = !_.isEmpty(defaultValues) ? defaultValues[name] : null;
        if (["body"].includes(name)) { //"title", 
            value = _.get(value, _selectedLangCode) || " "
        }
        switch (type) {
            case "bool":
                return value !== 0;
            default:
                return value;
        }
    };

    const getEndpoint = () => {
        const endpoint = itemId ? `${QUIZ_QUESTION_OPTIONS}` : `${QUIZ_QUESTIONS}/${questionId}/${QUIZ_QUESTION_OPTIONS}`;
        return `${endpoint}`
    }

    const onSubmit = async (data) => {
        setItemId(data.id)
        if (props.onSubmit) {
            window.setTimeout(() => {
                props.onSubmit()
            }, 500)
        }
    }

    let fields = 1
        ? [
            {
                elementType: "input",
                id: "body",
                name: "body",
                labelText: "Value",
                value: getValue("body"),
            },
            {
                elementType: "toggle",
                id: "is_correct",
                name: "is_correct",
                labelText: "Correct?",
                value: getValue("is_correct"),
                labelOff: "No. Switch to make it a correct option", //labelA
                labelOn: "Yes. Switch to make it a wrong option", //labelB
                // onChange: (e) => toggleOptionsList(e)
            }
        ]
        : [];

    const onChange = (key, value) => {
        const re = new RegExp("(body)")
        if (key.match(re)) {
            value = {
                ..._.get(defaultValues, key),
                [_selectedLangCode]: value

            }
        }
        console.log("setDefaultValues", {
            ...defaultValues,
            [key]: value
        })
        setDefaultValues({
            ...defaultValues,
            [key]: value
        });
    }

    const onSavingChange = (value) => {
        setSaving(value)
    }

    const defaultParams = () => {
        return {
            ...defaultValues,
            ..._defaultParams
        }
    }

    return (
        <>
            {_languageSelect}
            <div className={props.className} key={`question-option-form-${props.itemId}`}>
                {
                    saving ? <Loading /> : null
                }
                <Form
                    blockTouched={false}
                    itemId={itemId}
                    fields={fields}
                    endpoint={getEndpoint()}
                    loaded={loaded}
                    modal={props.modal}
                    onRequestClose={props.onRequestClose}
                    onSavingChange={(value) => onSavingChange(value)}
                    setAutoId={true}
                    onChange={(key, val) => onChange(key, val)}
                    defaultParams={defaultParams()}
                    onSubmit={(data) => onSubmit(data)}
                />
            </div>
        </>
    );
};

export default formWrapper(QuizQuestionOptionForm);
